import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbContaPublica } from 'app/abstract/full-pages/conta/conta-publica.abstract';

@Injectable({ providedIn: 'root' })
export class ContaPublicaService extends AbContaPublica {

  constructor(http: HttpClient) {
    super(http);
  }

  public getTipoContaLogadaPublica() {
    return this.get('public/contas/tipocontalogada');
  }


  public getTipoContaPublicaById(id: number) {
    return this.get(`public/contas/tipoconta/${id}`);
  }
}